<template>
    <div class="addentranceVehicle">
        <div class="nav clearfix">
            <row>
                <van-col span="2">
                    <Icon name="arrow-left" size="26" @click="getBack" />
                </van-col>
                <van-col span="18" align="center" justify="center" style="font-size:19px;">处理类型</van-col>
            </row>
        </div>
        <van-form class="form">
            <div class="dan" style="display:flex; margin:2vw;">
                <span style="font-size:20px;"><span style="font-size:6px;color:#f00;">*</span>处理方式</span>
                <van-radio-group v-model="submititem.processingMode" style="margin-left:20px;height:30px;" direction="horizontal" @change="processingModes(submititem.processingMode)">
                    <van-radio name="0" style="font-size:16px;">无需入场</van-radio>
                    <van-radio name="1" style="font-size:16px;">入场维修</van-radio>
                </van-radio-group>
            </div>
            <van-field
                v-model="submititem.maintenTypeName"
                :readonly="projectreadonly"
                autocomplete="off"
                :show-error="true"
                :disabled="true"
                :required="!projectreadonly"
                name="maintenTypeName"
                label="维修类型"
                :rules="[ projectreadonly?'':{ required: true, message: '必填' } ]"
                placeholder="选择维修类型"
                @click="!projectreadonly ? showmaintainItemse = true : showmaintainItemse==false" />
            <van-popup
                v-model="showmaintainItemse"
                :style="{ height: '35%' }"
                position="bottom">
                <van-picker
                    item-height="1.173rem"
                    show-toolbar
                    :columns="maintenTypes"
                    @cancel="showmaintainItemse = false"
                    @confirm="maintenTypeNamese" />
            </van-popup>
            <van-field
                v-model="submititem.examinator"
                label="检查人"
                placeholder="检查人"
                :border="true "
                :required="true"
                disabled
                bind:click-icon="onClickIcon"
                :rules="[ { required: true, message: '必填' } ]"
                bind:change="onChange" />
            <van-field
                v-model="submititem.examineTimes"
                icon="question-o"
                is-link
                disabled
                label="检查时间"
                :border="true"
                :required="true"
                maxlength="30"
                arrow-direction="down"
                placeholder="输入入场时间"
                bind:click-icon="onClickIcon"
                :rules="[ { required: true, message: '必填' } ]"
                @click="showDate" />

            <div style="padding:0 10px;">
                <row :gutter="20">
                    <van-col span="24">
                        <van-button round block type="info" class="nextSpan"
                            @click="submit(false)">提交</van-button>
                    </van-col>
                </row>
            </div>
            <div style="height:1.2rem;" />
        </van-form>
        <bottom />
    </div>
</template>

<script>
var moment = require('moment')

import { Icon, Notify, Form, Tab, Tabs, DatetimePicker, Popup, Cell, CellGroup, Toast, List, Button, Field, Switch, Radio, Col, Row, RadioGroup, Picker, Checkbox, CheckboxGroup } from 'vant'
import bottom from '@/components/bottom'
import { getDictionarySelect,getOdd } from '@/api/basics'
import { submitRecord, uploadAnnex } from '@/api/maintain'
import uuidv1 from 'uuid/v1'
export default {
    name: 'AddentranceVehicle',
    components: {
        bottom,
        Icon, [Button.name]: Button, [Col.name]: Col, Row, [CellGroup.name]: CellGroup, [Field.name]: Field, Notify, DatetimePicker, Popup, [Cell.name]: Cell, [Picker.name]: Picker, [Checkbox.name]: Checkbox, [CheckboxGroup.name]: CheckboxGroup, [Form.name]: Form
    },
    data() {
        return {
            radio: '1',
            value: '',
            submititem:
            {
                'id':uuid(),
                'vehicleId': '',
                'vehicleCode': '',
                'barCode': '',
                'enumVehicleStatus': 1,
                'chassisNumber': '',
                'category': '',
                'brand': '',
                'modelId': '',
                'model': '',
                'customer': '',
                'customerId': '',
                'phone': '',
                'owner': '',
                'entryTime': '',
                'drivers': [],
                'driver': '',
                'driverPhone': '',
                'outStockType': '',
                'faultDescription': '',
                'entranceUrl': '',
                'processingMode': '',
                'examinator': ''
            },
            fileList: [],
            maintenTypes: [],
            driversdata: '',
            date: false,
            projectreadonly: false,
            visitCurrentDate: new Date(),
            vehicleCodeList: [],
            barCodeList: [],
            vehicleCodeColumn: [],
            barCodeColumn: [],
            showPicker: false,
            showbarCode: false,
            showDrivers: false,
            driversColumn: [],
            checkedDrivers: [],
            images: [],
            showmaintainItemse: false
        }
    },
    created() {
        console.log(this.$store.state.user.photo)
    },
    mounted() {
        this.submititem = JSON.parse(this.$route.query.optdevice)
        this.fileList = this.$store.state.user.photo
        console.log(this.submititem, 'jrr')
        console.log(this.fileList, 'jrr')
        this.getOdd()

        // 获取维修类型
        getDictionarySelect({ Code: 'Maintain:MaintenceType' }).then(res => {
            if (res.isSuccess) {
                console.log(res.data)
                this.maintenTypes = res.data
                this.maintenTypes.forEach(item => {
                    item.text = item.name
                })
            }
        })
        this.visitSelectDate(new Date())
        console.log(this.$store.state.user,'this.$store.state.user')
        this.submititem.examinator = this.$store.state.user.userInfo.nickName
    },
    methods: {
        processingModes(val) {
            console.log(val)
            if (val == 0) {
                this.submititem.maintenTypeName = ''
                this.projectreadonly = true
            } else if(val==1){
                this.projectreadonly = false
            }
        },
        showDate() {
            this.date = !this.date
        },
        // 确认维修类型
        maintenTypeNamese(val) {
            console.log(val, 'jrr')
            this.maintenTypes.forEach(async res => {
                if (res.id == val.id) {
                    this.submititem.maintenTypeName = res.name
                    this.submititem.maintenTypeId = res.code
                    this.showmaintainItemse = false
                    this.submititem.factor = res.factor
                    this.submititem.code = res.code
                }
            })
        },
        // 上传照片
        upload(arr) {
            console.log(arr, 'zhao')
            const arrs = []
            arr.forEach(item => {
                arrs.push(new Promise((resolve, reject) => {
                    console.log(item)
                    const formData = new FormData()
                    formData.append('file', item.file)
                    uploadAnnex(formData).then(res => {
                        if (res.code == 200) {
                            // var data = JSON.parse(res.data)
                            resolve({ path: `${process.env.VUE_APP_IMG}/$res.data}` })
                        }
                    })
                }))
            })
            return arr
        },
        // 返回
        getBack() {
            this.$router.push({
                path:'/addentranceVehicle',
            })
        },
        visitSelectDate(date) {
            var date = new Date();
            var year = date.getFullYear(); //获取当前年份
            var month = date.getMonth() + 1; //获取当前月份
            var dat = date.getDate(); //获取当前日
            var hour = date.getHours(); //获取小时
            var minutes = date.getMinutes(); //获取分钟
            var second = date.getSeconds(); //获取秒
            const Time = year + '-' + month + '-' + dat + ' ' + hour + ':'+ minutes + ':'+ second;
            const Times = year + '-' + month + '-' + dat + ' ' + hour + ':'+ minutes + ':'+ second;
            this.submititem.examineTime = Time
            this.submititem.examineTimes = Times
            this.submititem.examineTime = this.moment().format('YYYY-MM-DD HH:mm:ss')
            this.submititem.examineTimes = this.moment().format('YYYY-MM-DD HH:mm:ss')

            this.date = false
        },
        PrefixInteger(num, length) {
            return (Array(length).join('0') + num).slice(-length);
        },
        getOdd() {
            let tenantCode = null
            if (!this.$store.state.user.userInfo.tenantId) {
                tenantCode = '0000'
            }else{
                tenantCode = this.PrefixInteger(this.$store.state.user.userInfo.tenantId,4)
            }
            var sheetNo = `PG${tenantCode}${this.moment().format('YYYY')}${moment().format('MM')}${moment().format('DD')}`
            getOdd(sheetNo)
                .then(res => {
                    if (res.isSuccess) {
                        this.submititem.workOrderSheetNo = res.data.sheetNo
                        console.log(res.data, '单号')
                    }
                })
        },
        // 提交
        submit(value) {
            console.log(this.submititem.processingMode, 'luyutong')
            if (!this.submititem.processingMode) {
                Toast('请选择处理方式')
                return false
            }
            if (!this.projectreadonly) {
                if (!this.submititem.maintenTypeName) {
                    Toast('维修类型不能为空')
                    return false
                }
            }

            if(this.submititem.processingMode == "1"){
                value = true
            }

            this.submititem.id=uuid()
            submitRecord(this.submititem).then((res) => {
                if (res.isSuccess) {
                    Notify({ type: 'success', message: '提交成功' })
                    // return
                    if (value) {
                        if (this.$_has('maintain:workorder:view')) {

                            let orderId = res.data
                            console.log('派工单ID:', orderId);

                            this.$router.push({
                                path: '/dispatchList',
                                query: {
                                    type: '处理',
                                    id: orderId
                                }
                            })
                        } else {
                            this.$router.push({
                                path: '/404'
                            })
                        }
                    } else {
                        this.$router.push({
                            path: '/entrancevehicle'
                        })
                    }
                } else {
                    Toast(res.message)
                    return false
                }
            })
        }
    }
}
</script>
<style lang='scss' scoped>
.dan{
    height:8vh;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
}
</style>
